module.exports = __webpack_public_path__ + "img/air-zoom-pegasus-37-womens-running-shoe.d02621c0.png";